// workarounds to block body scroll in safari mobile, updated for iOS 15
export default class FixBody {
  static block(height) {
    document.body.style.position = 'fixed';
    document.body.style.top = `-${height}px`;
    document.body.style.width = '100%';
    document.documentElement.style.height = `${window.innerHeight}px`;
  }

  static unblock(prevScrollY) {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.documentElement.style.height = '';
    window.scrollTo(0, prevScrollY);
  }
}
